import type { Message } from '../../stores/chatStore'
import { useChatStore } from '../../stores/chatStore'

interface EditPreviewProps {
  message: Message
}

/**
 * Edit preview bar shown above ChatInput when editing a message.
 * Shows original text with cancel button.
 */
export default function EditPreview({ message }: EditPreviewProps) {
  const setEditingMessage = useChatStore((state) => state.setEditingMessage)

  // Truncate long content
  const displayText = message.content.length > 100
    ? message.content.slice(0, 100) + '...'
    : message.content

  const handleCancel = () => {
    setEditingMessage(null)
  }

  return (
    <div data-testid="edit-preview" className="flex items-center gap-2 px-4 py-2 border-l-4 bg-amber-50 border-amber-400">
      {/* Edit icon */}
      <svg
        className="w-5 h-5 text-amber-500 flex-shrink-0"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
        />
      </svg>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div className="text-xs font-medium text-amber-600">
          Редактирование
        </div>
        <div className="text-sm text-amber-700/70 truncate">
          {displayText}
        </div>
      </div>

      {/* Cancel button */}
      <button
        data-testid="edit-cancel"
        onClick={handleCancel}
        className="p-1 hover:bg-amber-200 rounded-full transition-colors"
        aria-label="Cancel edit"
      >
        <svg
          className="w-5 h-5 text-amber-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
  )
}
